import clsx from 'clsx';
import { FIELD_TYPES } from '../lib/fieldTypes';

const GROUPS = ['Signature fields', 'Auto-filled fields', 'Standard fields'];

/**
 * The builder's field catalog. Items can be dragged onto a page (HTML5 drag)
 * or clicked to "arm" placement — the next click on a page drops the field.
 */
export default function FieldPalette({ armedKind, onArm }) {
  return (
    <div className="space-y-4">
      {GROUPS.map((group) => (
        <div key={group}>
          <h3 className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-slate-400">
            {group}
          </h3>
          <div className="space-y-1">
            {FIELD_TYPES.filter((t) => t.group === group).map(({ kind, label, icon: Icon }) => (
              <button
                key={kind}
                type="button"
                draggable
                onDragStart={(e) => {
                  e.dataTransfer.setData('application/x-sign-field', kind);
                  e.dataTransfer.effectAllowed = 'copy';
                }}
                onClick={() => onArm(armedKind === kind ? null : kind)}
                className={clsx(
                  'flex w-full cursor-grab items-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition-colors',
                  armedKind === kind
                    ? 'border-brand-600 bg-brand-600/10 text-brand-600'
                    : 'border-slate-200 bg-slate-100 text-slate-700 hover:border-slate-300 hover:bg-slate-200',
                )}
              >
                <Icon className="h-4 w-4 shrink-0" />
                {label}
              </button>
            ))}
          </div>
        </div>
      ))}
      <p className="text-xs leading-relaxed text-slate-400">
        Drag a field onto the document, or click one and then click where it should go.
      </p>
    </div>
  );
}
